import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Lightbox from 'react-images';
import { actionCreators } from '../store/modules/Image';
import ImageControl, { GetImageSrc } from './Image';
import { actionCreators as notificationActionCreators } from '../store/modules/Notification';

class ImageUpload extends Component {
  dropRef = React.createRef();

  dragCounter = 0;

  constructor(props) {
    super(props);
    this.state = {
      showImages: false,
      currentImage: 0,
      drag: false,
    };
  }

  componentDidMount() {
    const div = this.dropRef.current;
    div.addEventListener('dragenter', this.handleDragIn);
    div.addEventListener('dragleave', this.handleDragOut);
    div.addEventListener('dragover', this.handleDrag);
    div.addEventListener('drop', this.handleDrop);
  }

  componentWillReceiveProps(nextProps) {
    const {
      clearImage, form, single, onChange,
    } = this.props;

    if (nextProps.imageId) {
      if (form) {
        form.current.setFieldValue(
          single ? 'imageId' : 'imageIds',
          single ? nextProps.imageId : [...form.current.state.values.imageIds, nextProps.imageId],
        );
      }
      if (onChange) onChange(nextProps.imageId);
      clearImage();
    }
  }

  componentWillUnmount() {
    const div = this.dropRef.current;
    div.removeEventListener('dragenter', this.handleDragIn);
    div.removeEventListener('dragleave', this.handleDragOut);
    div.removeEventListener('dragover', this.handleDrag);
    div.removeEventListener('drop', this.handleDrop);
  }

  handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter = this.dragCounter + 1;
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      this.setState({ drag: true });
    }
  };

  handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.dragCounter = this.dragCounter - 1;
    if (this.dragCounter === 0) {
      this.setState({ drag: false });
    }
  };

  handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ drag: false });
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      this.handleFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
      this.dragCounter = 0;
    }
  };

  gotoPrevious() {
    const { currentImage } = this.state;

    this.setState({
      currentImage: currentImage - 1,
    });
  }

  gotoNext() {
    const { currentImage } = this.state;

    this.setState({
      currentImage: currentImage + 1,
    });
  }

  handleFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.handleFile(file);
    }
  }

  handleFile(file) {
    const { requestImagePost, addError } = this.props;

    const errorMessage = 'Please select a valid image (.jpg, .png, .gif) with min size 100x100 and aspect ratio 1:1.';
    const regex = new RegExp('([a-zA-Z0-9s_\\.-:])+(.jpg|.jpeg|.png|.gif)$');

    if (regex.test(file.name.toLowerCase())) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const image = new Image();
        image.onload = (ev) => {
          const { height } = ev.target;
          const { width } = ev.target;
          if (height < 100 || width < 100 || height !== width) {
            addError(errorMessage);
          } else {
            requestImagePost(file);
          }
        };
        image.src = e.target.result;
      };
      reader.readAsDataURL(file);
    } else {
      addError(errorMessage);
    }
  }

  render() {
    const { showImages, currentImage, drag } = this.state;
    const {
      imageIds, single, form, readOnly,
    } = this.props;

    let images = imageIds;

    if (single) images = imageIds.length > 0 && imageIds[0] ? [imageIds[0]] : [];

    return (
      <div className="img-well" ref={this.dropRef}>
        <button type="button"
          className="rt cr-edit"
          onClick={() => {
            if (images.length > 0) this.setState({ showImages: true });
          }}
          style={{ cursor: images.length > 0 ? 'pointer' : 'unset' }}>
          <ImageControl src={images.length > 0 ? GetImageSrc(images[images.length - 1], 170) : null} alt="upload" />
        </button>

        {drag && (
          <div className="image-drop" title="Drop Image">
            <span className="glyphicon glyphicon-download-alt" />
          </div>
        )}

        <Lightbox images={images.map(imageId => ({
          src: GetImageSrc(imageId),
          thumbnail: GetImageSrc(imageId, 50),
        }))}
          onClickPrev={() => this.gotoPrevious()}
          onClickNext={() => this.gotoNext()}
          onClickThumbnail={image => this.setState({
            currentImage: image,
          })
          }
          currentImage={currentImage}
          isOpen={showImages}
          showImageCount
          showThumbnails
          onClose={() => {
            this.setState({ showImages: false });
          }} />
        {!readOnly && (
          <label htmlFor="file-upload" className="custom-file-upload">
            Pievienot attēlu
            <span style={{
              position: 'absolute',
              fontSize: 10,
              marginTop: 17,
              marginLeft: -60,
            }}>
              malu attiecība 1:1
            </span>
            <span style={{
              position: 'absolute',
              fontSize: 10,
              marginTop: 30,
              marginLeft: -65,
            }}>
              optimāli 500x500px
            </span>
            <input type="file"
              id="file-upload"
              accept=".png, .jpg, .jpeg, .gif"
              onChange={event => this.handleFileSelect(event)} />
          </label>
        )}
        {images.length > 0
          && !readOnly && (
            <button type="button"
              className="glyphbutton clear-file"
              title="Delete"
              onClick={() => form.current.setFieldValue(single ? 'imageId' : 'imageIds', single ? null : [])}>
              <span className="btn-sm btn-danger link glyphicon glyphicon-minus pull-right" />
            </button>
        )}
      </div>
    );
  }
}

ImageUpload.propTypes = {
  imageIds: PropTypes.arrayOf(PropTypes.string),
  imageId: PropTypes.string,
  requestImagePost: PropTypes.func.isRequired,
  clearImage: PropTypes.func.isRequired,
  form: PropTypes.shape(),
  single: PropTypes.bool,
  readOnly: PropTypes.bool,
  onChange: PropTypes.func,
  addError: PropTypes.func.isRequired,
};

ImageUpload.defaultProps = {
  imageId: null,
  imageIds: [],
  single: false,
  readOnly: false,
  onChange: null,
  form: null,
};

export default connect(
  state => ({
    imageId: state.image.id,
  }),
  dispatch => bindActionCreators(
    {
      ...actionCreators,
      requestImagePost: actionCreators.requestPost,
      clearImage: actionCreators.clear,
      addError: notificationActionCreators.addError,
    },
    dispatch,
  ),
)(ImageUpload);



// WEBPACK FOOTER //
// ./src/controls/ImageUpload.jsx